import { startProlificSession } from '@/features/nectar/prolific/api'
import { setProlificSession } from '@/features/nectar/prolific/session'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const ProlificEntryPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const expired = searchParams.get('expired')
    if (expired) {
      setError('Your study session expired. Please return to Prolific and re-open the study from your dashboard.')
      return
    }

    const prolificPid = searchParams.get('PROLIFIC_PID')
    const studyId = searchParams.get('STUDY_ID')
    const sessionId = searchParams.get('SESSION_ID')

    if (!prolificPid || !studyId || !sessionId) {
      setError('This study link is missing required parameters.')
      return
    }

    startProlificSession({ prolificPid, studyId, sessionId })
      .then((res) => {
        if (cancelled) return
        setProlificSession(res.token, res.completionUrl)
        navigate(`/missions/prolific/${res.projectId}/tasks`, { replace: true })
      })
      .catch(() => {
        if (!cancelled) setError('This study is not available right now.')
      })

    return () => {
      cancelled = true
    }
  }, [searchParams, navigate])

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
      {error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <p>Setting up your study session...</p>
      )}
    </div>
  )
}

export default ProlificEntryPage
